import { Box } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const EvidenceTag = styled(Box)`
  padding: 8px 12px;
  inset: 0;

  border-right: 1px solid ${({ theme }) => theme.colors.grey_4};

  &:hover {
    background-color: ${({ theme }) => theme.colors.grey_5};
  }
`
